import { render, staticRenderFns } from "./ProductModal.vue?vue&type=template&id=6e8e3a81&"
import script from "./ProductModal.vue?vue&type=script&lang=js&"
export * from "./ProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\happyboxstore-repo\\shoppe\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e8e3a81')) {
      api.createRecord('6e8e3a81', component.options)
    } else {
      api.reload('6e8e3a81', component.options)
    }
    module.hot.accept("./ProductModal.vue?vue&type=template&id=6e8e3a81&", function () {
      api.rerender('6e8e3a81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Shoppe/components/ProductModal.vue"
export default component.exports